import React from 'react';

var digisignframe = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0px',
    zIndex: '99999',
    left: '0px',
    border: '0px',
    margin: '0px',
    padding: '0px',
    overflow: '0px'
};

const Iframe = ({ source }) => {

    if (!source) {
        return null;
    }


    const src = source;
    return (
        <iframe src={src} title="digisign iframe" style={digisignframe} sandbox="allow-scripts allow-same-origin allow-top-navigation allow-forms allow-pointer-lock allow-popups"></iframe>
    );
};

export default Iframe;


// WEBPACK FOOTER //
// ./src/components/Iframe.js